import { Component, input, ChangeDetectionStrategy } from '@angular/core';
import { CommonMessageWidget } from '@eforall/common';

@Component({
	selector: 'readonly-access',
	standalone: true,
	imports: [CommonMessageWidget],
	templateUrl: './readonly-access.widget.html',
	changeDetection: ChangeDetectionStrategy.Eager,
	styleUrls: ['./readonly-access.widget.scss'],
})
export class ReadonlyAccessWidget {

	public readonly = input.required<boolean>();

}